// extracted by mini-css-extract-plugin
export default {"container":"ErrorBox_container__Px+yd","title":"ErrorBox_title__x4AF8","description":"ErrorBox_description__fYTVf"};